import React, {forwardRef, useImperativeHandle} from 'react';
import TextField from "@mui/material/TextField";

const inputType = "outlined";

let ViewTxForm = (props, ref) => {
    const [id, setId] = React.useState("");
    const [type, setType] = React.useState("");
    const [amount, setAmount] = React.useState("");
    const [currency, setCurrency] = React.useState("");
    const [reference, setReference] = React.useState("");
    const [clientReference, setClientReference] = React.useState("");
    const [agentReference, setAgentReference] = React.useState("");
    const [referenceResponse, setReferenceResponse] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [createdAt, setCreatedAt] = React.useState("");
    const [updatedAt, setUpdatedAt] = React.useState("");

    useImperativeHandle(ref, () => ({
        getValues: () => {
            return ({id, type, currency, reference, status, amount});
        },
        reinit: () => {
            setId("");
            setType("");
            setCurrency("");
            setReference("");
            setClientReference("");
            setAgentReference("");
            setReferenceResponse("");
            setCreatedAt("");
            setUpdatedAt("");
            setAmount("");
            setStatus("");
            setMessage("");
        }
    }));

    React.useEffect(() => {
        let { data } = props;
        if(data) {
            setId(data.id);
            setType(data.type);
            setCurrency(data.currency);
            setAmount(data.amount);
            setReference(data.phone_number ?? data.request_data);
            setClientReference(`${data.client?.first_name || ''} (${data.client?.username || ''})`)
            setAgentReference(`${data.agent?.first_name || ''} (${data.agent?.username || ''})`)
            setMessage(data.message ?? '');
            setStatus(data.status);
            setReferenceResponse(data.response_data);
            setCreatedAt(new Date(data.created_at).toUTCString() + ' ' + new Date(data.created_at).toTimeString());
            setUpdatedAt(new Date(data.updated_at).toUTCString() + ' ' + new Date(data.updated_at).toTimeString());
        }
    }, [props.data]);

    return (
        <div>
            <div className="__line __fist">
                <TextField
                    label={"ID"}
                    value={id || ''}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Reference"}
                    value={reference}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Type"}
                    value={type.split("_").join(" ")}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Amount"}
                    value={amount + ' ' + currency}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Status"}
                    value={status.toLocaleLowerCase()}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Message/reason"}
                    value={message}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Client Reference"}
                    value={clientReference}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Agent Reference"}
                    value={agentReference}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Date created"}
                    value={createdAt}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Date updated"}
                    value={updatedAt}
                    variant={inputType}
                    className="__form-input"/>
            </div>
        </div>
    );
};

export default forwardRef(ViewTxForm);